import services from '@/services/ascentiaServiceIndex'
import { ACMF_REPORT_LIST_CONSTS as ARLC } from '../consts'
import moment from 'moment'
import _ from 'lodash'
import * as constants from '../../utilities/appConsts'
import {
  updateReportTypeDisplayName,
  fullReportTypeNumberName,
} from '../../utilities/reports'

const state = {
  airlinesData: [],
  masterModelsData: [],
  tailsData: [],
  systemsData: [],
  reportTypesData: [],
  parameterNamesData: [],
  reportListData: [],
  isReportListDataLoading: false,
  isReportExportLoading: false,
  isApuCycleExportLoading: false,
  isFaultMonitorExportLoading: false,
  isFleetAlertsExportLoading: false,
  isFleetMessagesExportLoading: false,
  savedReportFilterFields: [],
  eventReportListData: [],
  isEventReportListDataLoading: false,
  savedEventReportFilterFields: [],
  acmfReportAirlineMasterModelAgreement: [],
}

const getters = {
  // eslint-disable-next-line no-unused-vars
  mappedAcmfAirlines(state, getters, rootState, rootGetters) {
    if (state.airlinesData) {
      const airlineIds = rootGetters['globalFilter/airlineIdsSelected']
      const airlineAgreements = rootState.airlineManagement.allAgreements
      return state.airlinesData
        .filter(item => item.icaoCode !== null)
        .filter(item => airlineIds.length === 0 || airlineIds.includes(item.id))
        .map(item => {
          return {
            airlineId: item.id,
            text: item.name,
            value: item.id,
          }
        })
        .filter(
          item =>
            airlineAgreements.length === 0 ||
            airlineAgreements.some(
              aa => !aa.isExpired && aa.airlineId === item.airlineId,
            ),
        )
    }
    return []
  },
  // eslint-disable-next-line no-unused-vars
  mappedAcmfAirlinesAll(state, getters, rootState) {
    if (!state.airlinesData) return []
    else {
      const airlineAgreements = rootState.airlineManagement.allAgreements
      return state.airlinesData
        .filter(item => item.icaoCode !== null)
        .map(item => {
          return {
            airlineId: item.id,
            text: item.name,
            value: item.id,
          }
        })
        .filter(
          item =>
            airlineAgreements.length === 0 ||
            airlineAgreements.some(
              aa => !aa.isExpired && aa.airlineId === item.airlineId,
            ),
        )
    }
  },
  mappedAcmfAirlinesWithMasterModels(state) {
    if (state.airlinesData.length > 0 && state.masterModelsData.length > 0) {
      const items = state.airlinesData
        .map(item => {
          return {
            airlineId: item.id,
            airlineIcaoCode: item.icaoCode,
            text: item.name,
            value: item.id,
          }
        })
        .map(airlineItem => {
          const mms = state.masterModelsData
            .filter(mm => mm.airlineId === airlineItem.airlineId)
            .map(modelItem => {
              return {
                airlineId: modelItem.airlineId,
                masterModelId: modelItem.id,
                text: modelItem[constants.AIRLINE_TEXT_FIELD],
                value: modelItem.id,
              }
            })
            .sort((a, b) =>
              a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
            )
          return {
            ...airlineItem,
            items: mms,
          }
        })
      return items.sort((a, b) =>
        a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
      )
    }
    return []
  },
  // eslint-disable-next-line no-unused-vars
  mappedAcmfMasterModels(state, getters, rootState, rootGetters) {
    if (!state.masterModelsData) return []
    else {
      const selections = rootGetters['globalFilter/selections']
      const airlineAgreements = rootState.airlineManagement.allAgreements
      const masterModels = state.masterModelsData
        .map(item => {
          return {
            ...item,
            masterModelId: item.id,
          }
        })
        .filter(
          item =>
            selections.length === 0 ||
            selections.filter(
              selection =>
                selection.airlineId === item.airlineId &&
                selection.masterModelId === item.masterModelId,
            ).length > 0,
        )
        .map(item => {
          return {
            airlineId: item.airlineId,
            masterModelId: item.id,
            text: item[constants.AIRLINE_TEXT_FIELD],
            value: item.id,
          }
        })
        .filter(
          item =>
            airlineAgreements.length === 0 ||
            airlineAgreements.some(
              aa =>
                !aa.isExpired &&
                aa.airlineId === item.airlineId &&
                item.masterModelId === aa.masterModelId,
            ),
        )
      return masterModels
    }
  },
  // eslint-disable-next-line no-unused-vars
  mappedAcmfMasterModelsAll(state, getters, rootState) {
    if (!state.masterModelsData) return []
    else {
      const airlineAgreements = rootState.airlineManagement.allAgreements
      const masterModels = state.masterModelsData
        .map(item => {
          return {
            ...item,
            masterModelId: item.id,
          }
        })
        .map(item => {
          return {
            airlineId: item.airlineId,
            masterModelId: item.id,
            text: item[constants.AIRLINE_TEXT_FIELD],
            value: item.id,
          }
        })
        .filter(
          item =>
            airlineAgreements.length === 0 ||
            airlineAgreements.some(
              aa =>
                !aa.isExpired &&
                aa.airlineId === item.airlineId &&
                item.masterModelId === aa.masterModelId,
            ),
        )
      return masterModels
    }
  },
  mappedAcmfMasterModelsWithAirlines(state) {
    if (state.masterModelsData.length > 0 && state.airlinesData.length > 0) {
      const groupedByMasterModelId = _.groupBy(
        state.masterModelsData.map(item => {
          return {
            airlineId: item.airlineId,
            masterModelId: item.id,
            text: item[constants.AIRLINE_TEXT_FIELD],
            value: item.id,
          }
        }),
        'masterModelId',
      )
      const items = Object.keys(groupedByMasterModelId).map((key, index) => {
        const values = Object.values(groupedByMasterModelId)[index]
        const text = values.length > 0 ? values[0].text : ''
        return {
          masterModelId: Number(key),
          text,
          value: Number(key),
          items: state.airlinesData
            .map(item => {
              return {
                airlineId: item.id,
                text: item.name,
                value: item.id,
              }
            })
            .filter(
              item =>
                values.findIndex(
                  airline => airline.airlineId === item.airlineId,
                ) > -1,
            )
            .sort((a, b) =>
              a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
            ),
        }
      })

      return items.sort((a, b) =>
        a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
      )
    }

    return []
  },
  mappedAcmfTails(state, getters, rootState, rootGetters) {
    if (state.tailsData) {
      const selections = rootGetters['globalFilter/selections']

      return state.tailsData
        .filter(
          item =>
            selections.length === 0 ||
            selections.filter(
              selection =>
                selection.airlineId === item.airlineId &&
                selection.masterModelId === item.masterModelId,
            ).length > 0,
        )
        .map(item => {
          return {
            airlineId: item.airlineId,
            masterModelId: item.masterModelId,
            text: item.name,
            value: item.id,
          }
        })
    }
    return []
  },
  mappedAcmfTailsAll(state) {
    if (state.tailsData) {
      return state.tailsData.map(item => {
        return {
          airlineId: item.airlineId,
          masterModelId: item.masterModelId,
          text: item.name,
          value: item.id,
        }
      })
    }
    return []
  },
  mappedAcmfSystems(state, getters, rootState, rootGetters) {
    if (state.systemsData) {
      const masterModelIds = rootGetters['globalFilter/masterModelIdsSelected']

      return state.systemsData
        .filter(
          item =>
            masterModelIds.length === 0 ||
            masterModelIds.includes(item.masterModelId),
        )
        .map(item => {
          return {
            systemId: item.id,
            masterModelId: item.masterModelId,
            text: item.name,
            value: item.id,
          }
        })
    }
    return []
  },
  mappedAcmfSystemsAll(state) {
    if (state.systemsData) {
      return state.systemsData.map(item => {
        return {
          systemId: item.id,
          masterModelId: item.masterModelId,
          text: item.name,
          value: item.id,
        }
      })
    }
    return []
  },
  mappedAcmfReportTypes(state, getters, rootState, rootGetters) {
    if (state.reportTypesData) {
      const masterModelIds = rootGetters['globalFilter/masterModelIdsSelected']

      return state.reportTypesData
        .filter(
          item =>
            masterModelIds.length === 0 ||
            masterModelIds.includes(item.masterModelId),
        )
        .map(item => {
          return {
            id: item.id,
            displayName: item.displayName,
            reportNumber: item.number,
            systemId: item.systemId,
            isPerformanceReport: item.isPerformanceReport,
            masterModelId: item.masterModelId,
            text: updateReportTypeDisplayName(item.number, item.name),
            value: item.number,
            hasAcmfAnalytic: item.hasAcmfAnalytic,
          }
        })
    }
    return []
  },
  mappedAcmfReportTypesAll(state) {
    if (state.reportTypesData) {
      return state.reportTypesData.map(item => {
        return {
          id: item.id,
          reportNumber: item.number,
          systemId: item.systemId,
          masterModelId: item.masterModelId,
          text: updateReportTypeDisplayName(item.number, item.name),
          value: item.number,
        }
      })
    }
    return []
  },
  mappedAcmfParameterNames(state) {
    if (state.parameterNamesData) {
      return state.parameterNamesData.map(item => {
        return {
          reportNumber: item.reportNumber,
          text: item.parameterName,
          value: item.acmfDataElementId,
          shortName: item.shortName,
        }
      })
    }
    return []
  },
  mappedAcmfExportMasterModels() {
    const masterModel787 = [
      {
        text: '787',
        value: '787',
      },
    ]
    const masterModelA320 = [
      {
        text: 'A320',
        value: 'A320',
      },
    ]
    const masterModelA380 = [
      {
        text: 'A380',
        value: 'A380',
      },
    ]

    return [...masterModel787, ...masterModelA320, ...masterModelA380]
  },
}

const mutations = {
  [ARLC.UPDATE_REPORT_LIST_DATA]: (state, data) =>
    (state.reportListData = data),
  [ARLC.UPDATE_REPORT_LIST_DATA_LOADING]: (state, data) =>
    (state.isReportListDataLoading = data),
  [ARLC.UPDATE_REPORT_EXPORT_LOADING]: (state, data) =>
    (state.isReportExportLoading = data),
  [ARLC.UPDATE_APU_CYCLE_EXPORT_LOADING]: (state, data) =>
    (state.isApuCycleExportLoading = data),
  [ARLC.UPDATE_FAULT_MONITOR_EXPORT_LOADING]: (state, data) =>
    (state.isFaultMonitorExportLoading = data),
  [ARLC.UPDATE_FLEET_ALERTS_EXPORT_LOADING]: (state, data) =>
    (state.isFleetAlertsExportLoading = data),
  [ARLC.UPDATE_FLEET_MESSAGES_EXPORT_LOADING]: (state, data) =>
    (state.isFleetMessagesExportLoading = data),
  [ARLC.UPDATE_REPORT_LIST_FILTERS]: (state, data) =>
    (state.savedReportFilterFields = data),
  [ARLC.UPDATE_ACMF_AIRLINES]: (state, data) => (state.airlinesData = data),
  [ARLC.UPDATE_ACMF_MASTER_MODELS]: (state, data) =>
    (state.masterModelsData = data),
  [ARLC.UPDATE_ACMF_TAILS]: (state, data) => (state.tailsData = data),
  [ARLC.UPDATE_ACMF_SYSTEMS]: (state, data) => (state.systemsData = data),
  [ARLC.UPDATE_ACMF_REPORT_TYPES]: (state, data) =>
    (state.reportTypesData = data),
  [ARLC.UPDATE_ACMF_PARAMETER_NAMES]: (state, data) =>
    (state.parameterNamesData = data),
  [ARLC.UPDATE_EVENT_REPORT_LIST_DATA]: (state, data) =>
    (state.eventReportListData = data),
  [ARLC.UPDATE_EVENT_REPORT_LIST_DATA_LOADING]: (state, data) =>
    (state.isEventReportListDataLoading = data),
  [ARLC.UPDATE_EVENT_REPORT_LIST_FILTERS]: (state, data) =>
    (state.savedEventReportFilterFields = data),
  [ARLC.UPDATE_AIRLINE_MASTERMODEL_AGREEMENT]: (state, data) =>
    (state.acmfReportAirlineMasterModelAgreement = data),
}

const actions = {
  async [ARLC.GET_EVENT_REPORT_LIST_DATA](
    { commit, state, rootGetters },
    payload,
  ) {
    commit(ARLC.UPDATE_EVENT_REPORT_LIST_DATA_LOADING, true)
    try {
      const startDate = moment(payload.startDate).format(
        constants.API_DATE_FORMAT,
      )
      const endDate = moment(payload.endDate).format(constants.API_DATE_FORMAT)
      const selections = rootGetters['globalFilter/selections']

      const response = await services.acmf.saveData('eventReportListData', {
        startDate: startDate,
        endDate: endDate,
        combinationSets:
          selections && selections.length ? selections : undefined,
      })

      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.length
      ) {
        const reportTypes = state.reportTypesData
        const mappedData = response.data.map(item => {
          const reason =
            item.eventReason && item.eventReason.length > 0
              ? item.eventReason
              : item.reportName

          return Object.assign(item, {
            eventReason: reason.trim().replace(/_/g, ' '),
            reportType: fullReportTypeNumberName(
              reportTypes,
              item.reportNumber,
              item.masterModelId,
            ),
          })
        })

        commit(ARLC.UPDATE_EVENT_REPORT_LIST_DATA, mappedData)
      } else {
        commit(ARLC.UPDATE_EVENT_REPORT_LIST_DATA, [])
      }
    } catch (error) {
      console.log(ARLC.GET_EVENT_REPORT_LIST_DATA + ': error ' + error)
      commit(ARLC.UPDATE_EVENT_REPORT_LIST_DATA, [])
    } finally {
      commit(ARLC.UPDATE_EVENT_REPORT_LIST_DATA_LOADING, false)
    }
  },

  async [ARLC.GET_REPORT_LIST_DATA]({ commit, state }, payload) {
    commit(ARLC.UPDATE_REPORT_LIST_DATA_LOADING, true)
    try {
      const reportTypes = state.reportTypesData
      const startDate = moment(payload.startDate).format(
        constants.API_DATE_FORMAT,
      )
      const endDate = moment(payload.endDate).format(constants.API_DATE_FORMAT)
      let queryString = `?StartDate=${startDate}&EndDate=${endDate}`
      queryString += `&AirlineId=${payload.airlineId}`
      if (payload.aircraftIds.length > 0) {
        payload.aircraftIds.split(',').forEach(item => {
          queryString += `&AircraftIds=${item}`
        })
      }
      if (payload.masterModelIds.length > 0) {
        payload.masterModelIds.split(',').forEach(item => {
          queryString += `&MasterModelIds=${item}`
        })
      }
      if (payload.systemIds.length > 0) {
        payload.systemIds.split(',').forEach(item => {
          queryString += `&SystemIds=${item}`
        })
      }
      if (payload.reportNumbers.length > 0) {
        payload.reportNumbers.split(',').forEach(item => {
          queryString += `&ReportNumbers=${item}`
        })
      }
      const response = await services.acmf.getData(
        'reportListData',
        queryString,
        true,
      )
      const data = response.data || []
      const mappedData = data.map(item => {
        return {
          ...item,
          reportType: fullReportTypeNumberName(
            reportTypes,
            item.reportType,
            item.masterModelId,
          ),
        }
      })
      commit(ARLC.UPDATE_REPORT_LIST_DATA, mappedData)
    } catch (error) {
      console.log(ARLC.GET_REPORT_LIST_DATA + ': error ' + error)
      commit(ARLC.UPDATE_REPORT_LIST_DATA, [])
    } finally {
      commit(ARLC.UPDATE_REPORT_LIST_DATA_LOADING, false)
    }
  },
  async [ARLC.GET_REPORT_EXPORT_GIVEN_REPORT_OPTIONS]({ commit }, options) {
    try {
      commit(ARLC.UPDATE_REPORT_EXPORT_LOADING, true)
      const startDate = moment(options.dates.startDate).format(
        constants.API_DATE_FORMAT,
      )
      const endDate = moment(options.dates.endDate).format(
        constants.API_DATE_FORMAT,
      )
      const params = {
        startDate,
        endDate,
        reportType: options.reportType,
        airlineNames:
          options.airlineNames.length > 0
            ? options.airlineNames.toString()
            : '',
        tailNumbers:
          options.tailNumbers.length > 0 ? options.tailNumbers.toString() : '',
        isReducedApuList: options.isReducedApuList,
      }
      await services.acmf.getData('reportExportGivenOptions', params, true)
    } catch (error) {
      console.log(ARLC.GET_REPORT_EXPORT_GIVEN_REPORT_OPTIONS + ': error ')
    } finally {
      commit(ARLC.UPDATE_REPORT_EXPORT_LOADING, false)
    }
  },
  async [ARLC.GET_APU_CYCLE_EXPORT_GIVEN_OPTIONS]({ commit }, options) {
    try {
      commit(ARLC.UPDATE_APU_CYCLE_EXPORT_LOADING, true)
      const reportDate = moment(options.date).format(constants.API_DATE_FORMAT)
      const params = {
        reportDate,
        airlineIds:
          options.airlineIds.length > 0 ? options.airlineIds.toString() : '',
        masterModelNames:
          options.masterModelNames.length > 0
            ? options.masterModelNames.toString()
            : '',
      }
      await services.acmf.getData('apuCycleExportGivenOptions', params, true)
    } catch (error) {
      console.log(ARLC.GET_APU_CYCLE_EXPORT_GIVEN_OPTIONS + ': error ')
    } finally {
      commit(ARLC.UPDATE_APU_CYCLE_EXPORT_LOADING, false)
    }
  },
  async [ARLC.GET_FAULT_MONITOR_EXPORT_GIVEN_OPTIONS]({ commit }, options) {
    try {
      commit(ARLC.UPDATE_FAULT_MONITOR_EXPORT_LOADING, true)
      const startDate = moment(options.dates.startDate).format(
        constants.API_DATE_FORMAT,
      )
      const endDate = moment(options.dates.endDate).format(
        constants.API_DATE_FORMAT,
      )
      const params = {
        startDate,
        endDate,
        airlineIds:
          options.airlineIds.length > 0 ? options.airlineIds.toString() : '',
      }
      await services.acmf.getData(
        'faultMonitorExportGivenOptions',
        params,
        true,
      )
    } catch (error) {
      console.log(ARLC.GET_FAULT_MONITOR_EXPORT_GIVEN_OPTIONS + ': error ')
    } finally {
      commit(ARLC.UPDATE_FAULT_MONITOR_EXPORT_LOADING, false)
    }
  },
  async [ARLC.GET_FLEET_ALERTS_EXPORT_GIVEN_OPTIONS]({ commit }, options) {
    try {
      commit(ARLC.UPDATE_FLEET_ALERTS_EXPORT_LOADING, true)
      const startDate = moment(options.dates.startDate).format(
        constants.API_DATE_FORMAT,
      )
      const endDate = moment(options.dates.endDate).format(
        constants.API_DATE_FORMAT,
      )
      const params = {
        startDate,
        endDate,
        airlineIds:
          options.airlineIds.length > 0 ? options.airlineIds.toString() : '',
        masterModelNames:
          options.masterModelNames.length > 0
            ? options.masterModelNames.toString()
            : '',
      }
      await services.acmf.getData('fleetAlertsExportGivenOptions', params, true)
    } catch (error) {
      console.log(ARLC.GET_FLEET_ALERTS_EXPORT_GIVEN_OPTIONS + ': ' + error)
    } finally {
      commit(ARLC.UPDATE_FLEET_ALERTS_EXPORT_LOADING, false)
    }
  },
  async [ARLC.GET_FLEET_MESSAGES_EXPORT_GIVEN_OPTIONS]({ commit }, options) {
    try {
      commit(ARLC.UPDATE_FLEET_MESSAGES_EXPORT_LOADING, true)
      const startDate = moment(options.dates.startDate).format(
        constants.API_DATE_FORMAT,
      )
      const endDate = moment(options.dates.endDate).format(
        constants.API_DATE_FORMAT,
      )
      const params = {
        startDate,
        endDate,
        airlineIds:
          options.airlineIds.length > 0 ? options.airlineIds.toString() : '',
        ataChapterIds:
          options.ataChapterIds.length > 0
            ? options.ataChapterIds.toString()
            : '',
      }
      await services.acmf.getData(
        'fleetMessagesExportGivenOptions',
        params,
        true,
      )
    } catch (error) {
      console.log(ARLC.GET_FLEET_MESSAGES_EXPORT_GIVEN_OPTIONS + ': error ')
    } finally {
      commit(ARLC.UPDATE_FLEET_MESSAGES_EXPORT_LOADING, false)
    }
  },
  async [ARLC.GET_ACMF_AIRLINES]({ commit }) {
    try {
      const response = await services.acmf.getData('airlinesData')
      const data = response.data
      commit(ARLC.UPDATE_ACMF_AIRLINES, data)
    } catch (error) {
      console.log(`${[ARLC.GET_ACMF_AIRLINES]}: error ${error}`)
    }
  },
  async [ARLC.GET_ACMF_MASTER_MODELS]({ commit, rootGetters }) {
    try {
      const response = await services.acmf.getData('masterModelsData')
      const data = response.data
      commit(ARLC.UPDATE_ACMF_MASTER_MODELS, data)
      const masterModelData = data.map(item => {
        return {
          value: item.id,
          text: item.name,
        }
      })
      const masterModelAgreement = [
        ...rootGetters[
          'lookups/mappedDistinctAirlineWithMasterModelAgreementData'
        ](masterModelData),
      ]

      commit(ARLC.UPDATE_AIRLINE_MASTERMODEL_AGREEMENT, masterModelAgreement)
    } catch (error) {
      console.log(`${[ARLC.GET_ACMF_MASTER_MODELS]}: error ${error}`)
    }
  },
  async [ARLC.GET_ACMF_TAILS]({ commit }) {
    try {
      const response = await services.acmf.getData('tailsData')
      const data = response.data
      commit(ARLC.UPDATE_ACMF_TAILS, data)
    } catch (error) {
      console.log(`${[ARLC.GET_ACMF_TAILS]}: error ${error}`)
    }
  },
  async [ARLC.GET_ACMF_SYSTEMS]({ commit }) {
    try {
      const response = await services.acmf.getData('systemsData')
      const data = response.data
      commit(ARLC.UPDATE_ACMF_SYSTEMS, data)
    } catch (error) {
      console.log(`${[ARLC.GET_ACMF_SYSTEMS]}: error ${error}`)
    }
  },
  async [ARLC.GET_ACMF_REPORT_TYPES]({ commit }) {
    try {
      const response = await services.acmf.getData('reportTypesData')
      const data = response.data
      commit(ARLC.UPDATE_ACMF_REPORT_TYPES, data)
    } catch (error) {
      console.log(`${[ARLC.GET_ACMF_REPORT_TYPES]}: error ${error}`)
    }
  },
  async [ARLC.GET_ACMF_PARAMETER_NAMES]({ commit }) {
    try {
      const response = await services.acmf.getData('parameterNamesData')
      const data = response.data
      commit(ARLC.UPDATE_ACMF_PARAMETER_NAMES, data)
    } catch (error) {
      console.log(`${[ARLC.GET_ACMF_PARAMETER_NAMES]}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
